import React, { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toastWarning } from 'utils/toast';
import { DropsContext } from 'contexts/DropsContext';
import { GridContext } from 'contexts/GridContext';
import { RelatoriosContext } from 'contexts/RelatoriosContext';
import { ChequesBaixadosContext } from 'contexts/ChequesBaixadosContext';
import { useModal, useDialog } from 'components/Modals';
import ResumoModal from 'components/Modals/ResumoModal';
import DevoluçãoModal from '../Modals/DevoluçãoModal';
import DeleteModal from '../Modals/DeleteModal';
import Container from 'components/Container';
import Header from 'components/Header';
import Card from 'components/Card';
import Grid from 'components/Grid';
import Filter from './filter';
import mock from './mock';

const ChequesBaixados = () => {
  const rotina = 'ChequesBaixados';
  const titulo = 'Cheques Baixados';
  const navigate = useNavigate();
  const { openModal } = useModal();
  const { openDialog } = useDialog();
  const { drops } = useContext(DropsContext);
  const { exportPdf, exportXls } = useContext(GridContext);
  const { getURLRelatorio } = useContext(RelatoriosContext);
  const { chequesBaixados, getChequesBaixados, getLoading } = useContext(
    ChequesBaixadosContext
  );
  const { control, getValues, reset } = useForm({
    defaultValues: chequesBaixados?.filter,
  });

  const loadGrid = (props) => {
    if (props?.replace) {
      reset();
    }
    getChequesBaixados({ ...props, rotina, filter: getValues() });
  };

  const options = [
    {
      name: 'Exportar PDF',
      icon: 'file_download',
      action: () =>
        exportPdf({
          rotina,
          filter: getValues(),
          order: chequesBaixados?.order,
        }),
    },
    {
      name: 'Exportar XLS',
      icon: 'file_download',
      action: () =>
        exportXls({
          rotina,
          filter: getValues(),
          order: chequesBaixados?.order,
        }),
    },
    {
      name: 'Resumo',
      icon: 'summarize',
      action: () =>
        openModal(
          <ResumoModal
            colunas={chequesBaixados?.colunas}
            onSubmit={(group) =>
              navigate('/app/Resumo', {
                state: { rotina, group, filter: getValues() },
              })
            }
          />
        ),
    },
    {
      name: 'Recibos',
      icon: 'print',
      action: (selected) => {
        if (!Boolean(selected?.length)) {
          return toastWarning('Selecione ao menos um item');
        }
        getURLRelatorio({
          data: {
            codigo: 'RCB0000001',
            financeiro_id: JSON.stringify(
              selected?.map((s) => s?.financeiro_id)
            ),
          },
          cb: loadGrid,
        });
      },
    },
  ];

  const rowOptions = [
    {
      name: 'Detalhes',
      icon: 'visibility',
      show: ({ row }) => Boolean(row?.documento_id),
      action: ({ row }) => navigate(`/app/Documento/${row?.documento_id}`),
    },
    {
      name: 'Estornar',
      icon: 'delete',
      action: ({ row }) =>
        openModal(<DeleteModal item={row} callback={loadGrid} />),
    },
    {
      name: 'Recibo Completo',
      icon: 'print',
      menu: true,
      action: ({ row }) =>
        getURLRelatorio({
          data: {
            codigo: 'RCB0000002',
            financeiro_movimento_id: row?.financeiro_movimento_id,
          },
          cb: loadGrid,
        }),
    },
    {
      name: 'Demonstrativo do Movimento Financeiro',
      icon: 'print',
      menu: true,
      action: ({ row }) =>
        getURLRelatorio({
          data: {
            codigo: 'FINMOV0001',
            mov: row?.financeiro_movimento_id,
          },
          cb: loadGrid,
        }),
    },
    {
      name: 'Devolução',
      icon: 'settings_backup_restore',
      menu: true,
      action: ({ row }) =>
        openDialog(
          <DevoluçãoModal item={row} callback={loadGrid} />,
          'Devolução do Cheque'
        ),
    },
  ];

  return (
    <Container>
      <Header
        rotina={rotina}
        titulo={titulo}
        colunas={chequesBaixados?.colunas}
      />
      <Card>
        <Grid
          grid={chequesBaixados}
          mock={mock}
          options={options}
          rowOptions={rowOptions}
          control={control}
          checkboxSelection
          loading={getLoading}
          loadGrid={loadGrid}
          activeFilter={(getActiveFilter) => getActiveFilter(getValues())}
          FilterComponent={
            <Filter grid={chequesBaixados} control={control} drops={drops} />
          }
        />
      </Card>
    </Container>
  );
};

export default ChequesBaixados;
